import React from 'react';
import { InputCustom } from './styles';

export const InputAntdCustom = props => {
  return <InputCustom {...props} />;
};
